export default {
  home: 'Dashboards',
  servers: 'Servers',
  settings: 'Settings',
  user_settings: 'User',
  system_settings: 'System',
  ui_settings: 'Widgets',
  lists: 'Lists',
  reports: 'Reports'
}
